export const spotifyIds = [
  "4UADR6fNQfx4fxkiRQvSy2", // snail mail
  "7hY2Kc7Hvu0BudOoQwu8Ez", // animals as leaders
  "6LxcPUqx6noURdA5qc4BAT", // phoebe bridgers
  "0UPy6jay9WQ2HSOiYq7nJy", // kadhja bonet
  "49cgL2LMpDg3x70PWB13y3", // the weather station
  "7MKpQojXg5DbkZF68Zc1Ot", // king gizzard and the lizard wizard
  "4O0XfFuNoOGaHCqzelMylQ", // moonchild
  "6VSkzQqDG7trbQfiU0JxDM", // robert ellis
  "7KkpZSHhQXcecsB0Hgu4Wd", // kamasi washington
  "2sgbm2X8Ye9YIzvEUFGoar", // barr brothers
];

export const books = [
  {
    authorName: "George Saunders",
    title: "Lincoln in the Bardo",
    isbnNumber: "9780812995343",
    description: [
      "The novel takes place during and after the death of Abraham Lincoln's son William \"Willie\" Wallace Lincoln and deals with the president's grief at his loss. The bulk of the novel, which takes place over the course of a single evening, is set in the bardo—an intermediate space between life and rebirth."
    ]
  },
  {
    authorName: "Neal Stephenson",
    title: "Seveneves",
    isbnNumber: "9780062190376",
    description: [
      "The story tells of the desperate efforts to preserve Homo sapiens in the wake of apocalyptic events on Earth following the unexplained disintegration of the Moon, and the remaking of human society as a space-based civilization after a severe genetic bottleneck."
    ]
  },
  {
    authorName: "Lydia Davis",
    title: "Break It Down",
    isbnNumber: "9781852424213",
    description: [
      "A collection of short stories. My favorites were 'Break it Down', 'The House Plans', 'A Few Things Wrong With Me', 'City Employment', 'Once a Very Stupid Man', and 'The Sock'."
    ]
  },
  {
    authorName: "Alice Munro",
    title: "Hateship, Friendship, Courtship, Loveship, Marriage",
    isbnNumber: "0771065256",
    description: [
      "A collection of short stories. My favorites were 'Floating Bridge', 'Family Furnishings', Nettles', and 'Post and Beam'."
    ]
  },
  {
    authorName: "Yuval Noah Harari",
    title: "Sapiens",
    isbnNumber: "9780099590088",
    description: [
      "The book surveys the history of humankind from the evolution of archaic human species in the Stone Age up to the twenty-first century, focusing on our own species of human, Homo sapiens. The account is situated within a framework provided by the natural sciences, particularly evolutionary biology."
    ]
  }
];



// WEBPACK FOOTER //
// ./src/constants/about-data.js